import * as React from 'react';
import { Form } from 'react-bootstrap';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';

import { formSectionClass, formSectionClassColumn8, formSectionClassRow } from '../../helpers';

interface OwnProps {
	isDisabled: boolean;
}

type Props = OwnProps;
const CustomerSignatureSection: React.FC<Props> = (props) => {

	const {
		isDisabled,
	} = props;

	return (
		<Form className={formSectionClass}>
			<SegmentLabel
				label="Customer Signature"
				tooltip="Settings and permissions related to authorizing customer signatures on field reports generated for this job and its work orders."
			/>
			<div className={`${formSectionClassRow} m-t-m`}>
				<div className={formSectionClassColumn8}>
					<Field
						component={Checkbox}
						inline={true}
						isDisabled={isDisabled}
						isStandalone={true}
						label="Allow Customer Signature"
						name="allowCustomerSignature"
						propName="allowCustomerSignature"
					/>
				</div>
			</div>
		</Form>
	);
};

export default React.memo(CustomerSignatureSection);
